import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SessionStorageService } from './session-storage.service';
import { LocalStorageService } from './local-storage.service';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    SessionStorageService,
    LocalStorageService
  ]
})
export class StorageModule {
}
